import { gql } from '@apollo/client'
import { ClientApollo, ProductDetails } from '@nsw-paginas-deslogadas/typings'

const productsByIds = `
    productsByIds(productsId: $productsId) {
        lowestPriceBrand {
            brandId
            price
        }
        category {
			id
			name
		}
    }
`
const details = `
    productDetails(productId: $productId, brandId: $brandId) {
        id
        name
        synonymies
        coverageAns
        productInformation {
            description
            objective
            method
            readingSuggestion
            clinicalInterpretation
        }
        deadline {
            originProductId
            deadlineHours
            deadlineDays
            allowsUrgencyDeadline
            urgencyTimeDeadline
        }
    }
`

export const productDetailsQuery = gql(String.raw`
  query productDetails ($brandId: Int!, $productId: Int!, $productsId: [Int!]!) {
    ${productsByIds}
    ${details}
  }
`)

export const productDetails = (client: ClientApollo, brandId: number, productId: number): Promise<ProductDetails> => {
    return new Promise((resolve, reject) => {
        client
            .query({
                fetchPolicy: 'cache-first',
                query: productDetailsQuery,
                variables: { brandId, productId, productsId: [productId] },
            })
            .then(result => {
                resolve({ ...result.data.productDetails, ...result.data.productsByIds[0] })
            })
            .catch(reject)
    })
}
